<template>
  <v-card class="pt-4">
    <transition name="fade">
      <v-alert
        v-if="changeEmailAlert.show"
        :icon="changeEmailAlert.icon"
        :type="changeEmailAlert.type"
        dismissible
        class="change-email-alert mb-3 mx-4"
        border="left"
        dense
        outlined
      >
        <div class="text-caption font-weight-bold change-email-title">{{ changeEmailAlert.title }}</div>
        <div class="text-caption mt-1 change-email-message">{{ changeEmailAlert.message }}</div>
      </v-alert>
    </transition>
    <transition name="fade">
      <v-alert
        v-if="sendLinkAlert.show"
        :icon="sendLinkAlert.icon"
        :type="sendLinkAlert.type"
        dismissible
        class="send-link-alert mb-3 mx-4"
        border="left"
        dense
        outlined
      >
        <div class="text-caption font-weight-bold send-link-title">{{ sendLinkAlert.title }}</div>
        <div class="text-caption mt-1 send-link-message">{{ sendLinkAlert.message }}</div>
      </v-alert>
    </transition>
    <v-form>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItemData.fullname"
                label="Fullname"
                :error-messages="fullnameErrors"
                @change="$v.editedItemData.fullname.$touch()"
                @blur="$v.editedItemData.fullname.$touch()"
              />
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItemData.username"
                label="Username"
                :error-messages="usernameErrors"
                @change="$v.editedItemData.username.$touch()"
                @blur="$v.editedItemData.username.$touch()"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <div class="d-flex align-center">
                <v-text-field
                  v-model="editedItemData.email"
                  :error-messages="emailErrors"
                  @change="$v.editedItemData.email.$touch()"
                  @blur="$v.editedItemData.email.$touch()"
                  label="Email"
                  :disabled="editedIndex > -1"
                  class="flex-grow-1"
                />
                <v-btn
                  v-if="editedIndex > -1"
                  outlined
                  small
                  color="primary"
                  class="text-none ml-2 rounded-pill"
                  :disabled="editedItemData.status !== '1' || isChangeEmailCooldown"
                  @click="handleChangeEmail"
                >
                  {{ changeEmailButtonText }}
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="editedItemData.status_change_email_label && editedItemData.status_change_email_label.trim()" class="mt-n4 pt-0">
              <v-alert type="warning" dense outlined border="left" class="mb-2">
                <div class="text-caption mt-1">{{ editedItemData.status_change_email_label.charAt(0).toUpperCase() + editedItemData.status_change_email_label.slice(1) }}</div>
              </v-alert>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedIndex < 0 && editedIndex != -2"
            >
              <v-text-field
                v-model="editedItemData.password"
                :error-messages="passwordErrors"
                @change="$v.editedItemData.password.$touch()"
                @blur="$v.editedItemData.password.$touch()"
                @input="$v.editedItemData.password.$touch()"
                label="Password"
                :append-icon="passwordFieldType ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="() => (passwordFieldType = !passwordFieldType)"
                :type="passwordFieldType ? 'password' : 'text'"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedIndex < 0 && editedIndex != -2"
            >
              <v-text-field
                v-model="editedItemData.passwordConfirmation"
                :error-messages="passwordConfirmationErrors"
                @change="$v.editedItemData.passwordConfirmation.$touch()"
                @blur="$v.editedItemData.passwordConfirmation.$touch()"
                @input="$v.editedItemData.passwordConfirmation.$touch()"
                label="Password Confirmation"
                :append-icon="
                  passwordConfirmFieldType ? 'mdi-eye-off' : 'mdi-eye'
                "
                @click:append="
                  () => (passwordConfirmFieldType = !passwordConfirmFieldType)
                "
                :type="passwordConfirmFieldType ? 'password' : 'text'"
              />
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItemData.mobile_phone"
                :error-messages="mobilePhoneErrors"
                @change="$v.editedItemData.mobile_phone.$touch()"
                @blur="$v.editedItemData.mobile_phone.$touch()"
                label="Mobile Phone"
              />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="editedItemData.role"
                :error-messages="roleErrors"
                @change="$v.editedItemData.role.$touch()"
                @blur="$v.editedItemData.role.$touch()"
                :items="itemsRole"
                label="role"
                item-text="role"
                item-value="role"
                clearable
                return-object
              />
            </v-col>

            <v-col cols="12" sm="12" md="12" v-if="allowMapping">
              <v-divider class="mb-4"></v-divider>
              <div v-for="(prop, index) in componentsWilayah" :key="index">
                <user-wilayah
                  :listWilayah="listWilayah"
                  :componentsWilayah="componentsWilayah"
                  :kodeWilayah="prop.kode_wilayah"
                  :kodepos="prop.kodepos"
                  :kodeposAll="prop.kodepos_all"
                  :index="index"
                  :removeWilayahParent="removeWilayah"
                  :setActiveButtonParrent="setActiveButton"
                  :setWilayahByIndexParent="setWilayahByIndex"
                  :activeButton="activeButton"
                ></user-wilayah>
              </div>
              <v-btn
                :disabled="activeButton"
                small
                block
                color="primary"
                @click="addWilayah"
                >Tambah Wilayah
                <v-icon small class="ml-1"
                  >mdi-plus-circle-outline</v-icon
                ></v-btn
              >

              <v-divider class="mt-4"></v-divider>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="editedItemData.status"
                :error-messages="statusErrors"
                @change="$v.editedItemData.status.$touch()"
                @blur="$v.editedItemData.status.$touch()"
                :items="filteredStatusOptions"
                label="Status"
                item-text="text"
                item-value="value"
                clearable
                :disabled="isStatusFieldDisabled"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="editedItemData.status === '3'" class="mt-n4 pt-0">
              <v-alert type="info" dense outlined border="left" class="mb-2" icon="mdi-information">
                <div class="text-caption">This account is dormant and cannot be manually activated. To reactivate the account, send an activation link to the user.</div>
              </v-alert>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="editedItemData.status === '3'" class="mt-n4 pt-0">
              <v-btn
                outlined
                small
                color="primary"
                class="text-none rounded-pill mt-2"
                :disabled="isSendLinkCooldown"
                @click="handleSendLink"
              >
                {{ sendLinkButtonText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close"> Batal </v-btn>
        <v-btn 
          color="blue darken-1"
          text
          :loading="loading"
          :disabled="loading"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  minLength,
  sameAs,
} from 'vuelidate/lib/validators';
import { date, showAlert } from '../../../../lib/helpers';
import CustomEncryption from '../../../../lib/CustomEncryption';
import { dataListStatusUser, dataExtraString3 } from '../../../../store/params';

export default {
  components: { UserWilayah: () => import('../../../table/UserWilayah.vue') },
  props: ['editedItem', 'editedIndex'],
  mixins: [validationMixin],
  validations: {
    editedItemData: {
      fullname: { required },
      email: {
        required,
        email,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.email == null ||
              this.errorValidation.email.length < 1)
          );
        },
      },
      mobile_phone: { required, numeric },
      role: { required },
      status: { required },
      password: {
        required(value) {
          if (this.editedIndex < 0) {
            return value != '';
          }
          return true;
        },
        minLength: minLength(12),
        upperCase(value) {
          if (this.editedIndex < 0) {
            const pattern = /[A-Z]/;
            return !!pattern.test(value);
          }
          return true;
        },
        lowerCase(value) {
          if (this.editedIndex < 0) {
            const pattern = /[a-z]/;
            return !!pattern.test(value);
          }
          return true;
        },
        specialChar(value) {
          if (this.editedIndex < 0) {
            const pattern = /[\x21-\x2f\x3A-\x40\x5B-\x60\x7B-\x7E]/;
            return !!pattern.test(value);
          }
          return true;
        },
        numeric(value) {
          if (this.editedIndex < 0) {
            const pattern = /\d/;
            return !!pattern.test(value);
          }
          return true;
        },
      },
      passwordConfirmation: {
        required(value) {
          if (this.editedIndex < 0) {
            return value != '';
          }
          return true;
        },
        sameAsPassword: sameAs('password'),
      },
      username: {
        required,
        whitespace(value) {
          const pattern = /\s/;
          return !pattern.test(value);
        },
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.username == null ||
              this.errorValidation.username.length < 1)
          );
        },
      },
    },
  },
  async mounted() {
    this.getRoles();
    this.getListWilayah();
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this.sendLinkCountdownInterval) {
      clearInterval(this.sendLinkCountdownInterval);
    }
    if (this.changeEmailAlertTimeout) {
      clearTimeout(this.changeEmailAlertTimeout);
    }
    if (this.sendLinkAlertTimeout) {
      clearTimeout(this.sendLinkAlertTimeout);
    }
  },
  computed: {
    formTitle() {
      if (this.editedIndex != -1) {
        return this.editedIndex == -2 ? 'View User' : 'Edit User';
      }
      return 'New User';
    },
    isChangeEmailCooldown() {
      return this.changeEmailCountdown > 0;
    },
    changeEmailButtonText() {
      if (this.changeEmailCountdown > 0) {
        const minutes = Math.floor(this.changeEmailCountdown / 60);
        const seconds = this.changeEmailCountdown % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
      return 'Change Email';
    },
    isSendLinkCooldown() {
      return this.sendLinkCountdown > 0;
    },
    sendLinkButtonText() {
      if (this.sendLinkCountdown > 0) {
        const minutes = Math.floor(this.sendLinkCountdown / 60);
        const seconds = this.sendLinkCountdown % 60;
        return `Resend Link ${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
      return 'Send Link';
    },
    editedItemData: {
      get() {
        return this.editedItem;
      },
      set(newValue) {
        this.$emit('update:editedItem', newValue);
      },
    },
    loading() {
      return this.$store.state.users.loading;
    },
    listWilayah() {
      return this.$store.state.users.listWilayah;
    },

    errorValidation() {
      return this.$store.state.users.errors;
    },
    itemsRole() {
      return this.$store.state.rbac.role.allActiveRole;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.editedItemData.username.$dirty) {
        return errors;
      }
      if (!this.$v.editedItemData.username.required) {
        errors.push('Username is required.');
      }
      if (!this.$v.editedItemData.username.whitespace) {
        errors.push("Can't contain whitespace.");
      }
      if (!this.$v.editedItemData.username.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.username != null
        ) {
          this.errorValidation.username.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItemData.email.$dirty) return errors;
      if (!this.$v.editedItemData.email.email)
        errors.push('Must be valid e-mail');
      if (!this.$v.editedItemData.email.required)
        errors.push('E-mail is required');
      if (!this.$v.editedItemData.email.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.email != null
        ) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    fullnameErrors() {
      const errors = [];
      if (!this.$v.editedItemData.fullname.$dirty) return errors;
      if (!this.$v.editedItemData.fullname.required) {
        errors.push('Fullname is required');
      }
      return errors;
    },
    roleErrors() {
      const errors = [];
      if (!this.$v.editedItemData.role.$dirty) return errors;
      if (!this.$v.editedItemData.role.required)
        errors.push('Role is required');
      return errors;
    },
    statusErrors() {
      const errors = [];
      if (!this.$v.editedItemData.status.$dirty) return errors;
      if (!this.$v.editedItemData.status.required) {
        errors.push('Status is required');
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.editedItemData.password.$dirty) return errors;
      if (!this.$v.editedItemData.password.required) {
        errors.push('Password is required');
      }
      if (!this.$v.editedItemData.password.lowerCase) {
        errors.push('Password must have lowercase character');
      }
      if (!this.$v.editedItemData.password.upperCase) {
        errors.push('Password must have uppercase character');
      }
      if (!this.$v.editedItemData.password.numeric) {
        errors.push('Password must have numeric character');
      }
      if (!this.$v.editedItemData.password.specialChar) {
        errors.push('Password must have special character');
      }

      if (!this.$v.editedItemData.password.minLength) {
        errors.push('Password must be at least 12 characters long');
      }
      return errors;
    },
    passwordConfirmationErrors() {
      const errors = [];
      if (!this.$v.editedItemData.passwordConfirmation.$dirty) return errors;
      if (!this.$v.editedItemData.passwordConfirmation.required) {
        errors.push('Password Confirmation is required');
      }
      if (!this.$v.editedItemData.passwordConfirmation.sameAsPassword) {
        errors.push('Passwords must be identical.');
      }
      return errors;
    },
    mobilePhoneErrors() {
      const errors = [];
      if (!this.$v.editedItemData.mobile_phone.$dirty) return errors;
      if (!this.$v.editedItemData.mobile_phone.numeric) {
        errors.push('Must be numeric');
      }
      if (!this.$v.editedItemData.mobile_phone.required) {
        errors.push('Mobile Phone is required');
      }
      if (
        this.errorValidation != null &&
        this.errorValidation.mobile_phone != null
      ) {
        this.errorValidation.mobile_phone.forEach((item) => {
          errors.push(item);
        });
      }
      return errors;
    },
    editedItemRole() {
      return this.editedItemData?.role?.role || this.editedItemData?.role;
    },
    allowMapping() {
      const allowChange = this.eheckAloowRole(
        this.editedItemData?.role?.role_type
      );
      const checkAllowExist = this.checkInRole(this.editedItemRole);

      const allowData = allowChange || checkAllowExist;
      return allowData;
    },
    allowSave() {
      const returnAllow =
        !this.activeButton && this.componentsWilayah.length > 0;
      return this.allowMapping ? returnAllow : true;
    },
    filteredStatusOptions() {
      if (this.editedIndex > -1 && this.editedItemData.status === '3') {
        return this.listStatusUser;
      }
      return this.listStatusUser.filter(item => item.value === '0' || item.value === '1');
    },
    isStatusFieldDisabled() {
      return this.editedIndex > -1 && this.editedItemData.status === '3';
    },
  },
  watch: {
    'editedItemData.email': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit('users/clearErrorVariable', 'email');
          }
        }
      },
    },

    'editedItemData.username': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.username != null &&
            val != this.errorValidation.username
          ) {
            this.$store.commit('users/clearErrorVariable', 'username');
          }
        }
      },
    },
    'editedItemData.mobile_phone': {
      handler() {
        if (this.errorValidation != null) {
          if (this.errorValidation.mobile_phone != null) {
            this.$store.commit('users/clearErrorVariable', 'mobile_phone');
          }
        }
      },
    },
    'editedItemData.role': {
      handler(val) {
        if (val && !this.eheckAloowRole(val.role_type)) {
          this.componentsWilayah = [];
          this.activeButton = false;
        }
      },
    },
    'editedItemData.status': {
      handler(val) {
        if (val !== '1') {
          this.changeEmailCountdown = 0;
          if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
          }
          const storageKey = `change_email_countdown_${this.editedItemData?.id}`;
          localStorage.removeItem(storageKey);
        } else {
          this.initChangeEmailCountdown();
        }
        
        if (val !== '3') {
          this.sendLinkCountdown = 0;
          if (this.sendLinkCountdownInterval) {
            clearInterval(this.sendLinkCountdownInterval);
          }
          const sendLinkStorageKey = `send_link_countdown_${this.editedItemData?.id}`;
          localStorage.removeItem(sendLinkStorageKey);
        } else {
          this.initSendLinkCountdown();
        }
      },
    },
    editedItemData: {
      immediate: true,
      handler() {
        this.getUserWilayahKodepos(this.editedItem?.role, this.editedItem?.id);
        if (this.editedItemData.status === '1') {
          this.initChangeEmailCountdown();
        }
        if (this.editedItemData.status === '3') {
          this.initSendLinkCountdown();
        }
      },
    },
  },
  data: () => ({
    activeButton: false,
    componentsWilayah: [],
    listStatusUser: dataListStatusUser,
    passwordFieldType: true,
    passwordConfirmFieldType: true,
    changeEmailCountdown: 0,
    countdownInterval: null,
    changeEmailAlert: {
      show: false,
      icon: 'mdi-check-circle',
      type: 'success',
      title: '',
      message: '',
    },
    changeEmailAlertTimeout: null,
    sendLinkCountdown: 0,
    sendLinkCountdownInterval: null,
    sendLinkAlert: {
      show: false,
      icon: 'mdi-check-circle',
      type: 'success',
      title: '',
      message: '',
    },
    sendLinkAlertTimeout: null,
  }),
  methods: {
    checkInRole(role) {
      return this.itemsRole.some(
        (item) => item.role === role && this.eheckAloowRole(item.role_type)
      );
    },
    eheckAloowRole(roleType) {
      const allow = ['approver1', 'approver2', 'inputer'];

      return allow.includes(roleType);
    },
    setActiveButton(val) {
      this.activeButton = val;
    },
    removeWilayah(index) {
      this.componentsWilayah.splice(index, 1);
    },
    addWilayah() {
      const wilayah = { kode_wilayah: '', kodepos: [] };
      this.setActiveButton(true);
      this.componentsWilayah.push(wilayah);
    },
    getUserWilayahKodepos(role, userId) {
      const allow = this.checkInRole(role);
      if (allow) {
        this.$store
          .dispatch('users/getMappingUser', {
            date,
            userId,
          })
          .then((res) => {
            this.componentsWilayah = res;
          });
      }
    },
    setWilayahByIndex(indexToUpdate, kodeposAllUpdate, valueName) {
      Object.assign(this.componentsWilayah[indexToUpdate], {
        [valueName]: kodeposAllUpdate,
      });
    },
    getListWilayah() {
      this.$store.dispatch('users/fetchWilayah', {
        date,
      });
    },

    close() {
      this.componentsWilayah = [];
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      if (this.sendLinkCountdownInterval) {
        clearInterval(this.sendLinkCountdownInterval);
      }
      this.$emit('closeParent');
    },
    initChangeEmailCountdown() {
      if (this.editedItemData.status !== '1') {
        this.changeEmailCountdown = 0;
        return;
      }
      
      const storageKey = `change_email_countdown_${this.editedItemData?.id}`;
      const savedData = localStorage.getItem(storageKey);
      if (savedData) {
        const { expireTime } = JSON.parse(savedData);
        const remainingTime = Math.floor((expireTime - Date.now()) / 1000);
        if (remainingTime > 0) {
          this.changeEmailCountdown = remainingTime;
          this.startCountdownTimer();
        } else {
          localStorage.removeItem(storageKey);
          this.changeEmailCountdown = 0;
        }
      }
    },
    async handleChangeEmail() {
      if (this.editedItemData.status !== '1') {
        showAlert(
          this.$store,
          'User status must be Active to change email!',
          'mdi-alert',
          'red'
        );
        return;
      }
      
      const storageKey = `change_email_countdown_${this.editedItemData?.id}`;
      const countdownDuration = 5 * 60;
      const expireTime = Date.now() + countdownDuration * 1000;
      
      try {
        const responseData = await this.$store.dispatch('users/changeEmail', {
          userId: this.editedItemData.id,
          email: this.editedItemData.email,
          date,
        });
        
        if (responseData?.code === '200' || responseData?.code === 200) {
          localStorage.setItem(storageKey, JSON.stringify({ expireTime }));
          this.changeEmailCountdown = countdownDuration;
          this.startCountdownTimer();
          
          this.showChangeEmailAlert(
            'success',
            'Activation link has been sent to the user\'s email address.',
            'Please check the inbox and click the activation link to complete the status update.'
          );
          
          this.$nextTick(() => {
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        } else {
          const errorMessage = typeof responseData?.data === 'string' 
            ? responseData.data 
            : responseData?.message_en || 'Failed to send change email request';
          
          showAlert(
            this.$store,
            errorMessage,
            'mdi-alert',
            'red'
          );
        }
      } catch (error) {
        showAlert(
          this.$store,
          'Error sending change email request',
          'mdi-alert',
          'red'
        );
      }
    },
    showChangeEmailAlert(type, title, message) {
      if (this.changeEmailAlertTimeout) {
        clearTimeout(this.changeEmailAlertTimeout);
      }
      
      this.changeEmailAlert = {
        show: true,
        icon: type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle',
        type,
        title,
        message,
      };
      
      this.changeEmailAlertTimeout = setTimeout(() => {
        this.changeEmailAlert.show = false;
      }, 6000);
    },
    startCountdownTimer() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      this.countdownInterval = setInterval(() => {
        if (this.changeEmailCountdown > 0) {
          this.changeEmailCountdown -= 1;
        } else {
          clearInterval(this.countdownInterval);
          const storageKey = `change_email_countdown_${this.editedItemData?.id}`;
          localStorage.removeItem(storageKey);
        }
      }, 1000);
    },
    initSendLinkCountdown() {
      if (this.editedItemData.status !== '3') {
        this.sendLinkCountdown = 0;
        return;
      }
      
      const storageKey = `send_link_countdown_${this.editedItemData?.id}`;
      const savedData = localStorage.getItem(storageKey);
      if (savedData) {
        const { expireTime } = JSON.parse(savedData);
        const remainingTime = Math.floor((expireTime - Date.now()) / 1000);
        if (remainingTime > 0) {
          this.sendLinkCountdown = remainingTime;
          this.startSendLinkCountdownTimer();
        } else {
          localStorage.removeItem(storageKey);
          this.sendLinkCountdown = 0;
        }
      }
    },
    async handleSendLink() {
      if (this.editedItemData.status !== '3') {
        showAlert(
          this.$store,
          'User status must be Dormant to send activation link!',
          'mdi-alert',
          'red'
        );
        return;
      }
      
      const storageKey = `send_link_countdown_${this.editedItemData?.id}`;
      const countdownDuration = 5 * 60;
      const expireTime = Date.now() + countdownDuration * 1000;
      
      try {
        const responseData = await this.$store.dispatch('users/sendUserDormantLink', {
          userId: this.editedItemData.id,
          date,
        });
        
        if (responseData?.code === '200' || responseData?.code === 200) {
          localStorage.setItem(storageKey, JSON.stringify({ expireTime }));
          this.sendLinkCountdown = countdownDuration;
          this.startSendLinkCountdownTimer();
          
          this.showSendLinkAlert(
            'success',
            'Activation link has been sent to the user\'s email address.',
            'Please check the inbox and click the activation link to complete the status update.'
          );
          
          this.$nextTick(() => {
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        } else {
          const errorMessage = typeof responseData?.data === 'string' 
            ? responseData.data 
            : responseData?.message_en || 'Failed to send activation link';
          
          showAlert(
            this.$store,
            errorMessage,
            'mdi-alert',
            'red'
          );
        }
      } catch (error) {
        showAlert(
          this.$store,
          'Error sending activation link',
          'mdi-alert',
          'red'
        );
      }
    },
    showSendLinkAlert(type, title, message) {
      if (this.sendLinkAlertTimeout) {
        clearTimeout(this.sendLinkAlertTimeout);
      }
      
      this.sendLinkAlert = {
        show: true,
        icon: type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle',
        type,
        title,
        message,
      };
      
      this.sendLinkAlertTimeout = setTimeout(() => {
        this.sendLinkAlert.show = false;
      }, 6000);
    },
    updateSendLinkMessage(type, title, message) {
      this.sendLinkAlert = {
        show: true,
        icon: type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle',
        type,
        title,
        message,
      };
    },
    startSendLinkCountdownTimer() {
      if (this.sendLinkCountdownInterval) {
        clearInterval(this.sendLinkCountdownInterval);
      }
      this.sendLinkCountdownInterval = setInterval(() => {
        if (this.sendLinkCountdown > 0) {
          this.sendLinkCountdown -= 1;
        } else {
          clearInterval(this.sendLinkCountdownInterval);
          const storageKey = `send_link_countdown_${this.editedItemData?.id}`;
          localStorage.removeItem(storageKey);
        }
      }, 1000);
    },
    resetUniqueValidation() {
      this.$store.commit('users/clearErrors');
    },
    getRoles() {
      this.$store.dispatch('rbac/role/fetchActiveRoles', {
        date,
      });
    },

    extractErrorMessage(responseData, defaultMessage) {
      if (!responseData) return defaultMessage;
      
      const { data, message_en } = responseData;
      
      if (typeof data === 'string' && data.trim()) {
        return data;
      }
      
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const hasFieldErrors = Object.keys(data).some(
          (field) => Array.isArray(data[field]) && data[field].length > 0
        );
        if (hasFieldErrors) {
          return defaultMessage;
        }
      }
      
      return message_en || defaultMessage;
    },
    async save() {
      this.$store.commit('users/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();

      if (!this.allowSave) {
        showAlert(
          this.$store,
          'Pilih minimal satu wilayah !',
          'mdi-alert',
          'red'
        );
      } else if (!this.$v.$invalid) {
        const speEncrypt = new CustomEncryption();
        const extras = speEncrypt.decryption({
          enc: process.env.VUE_APP_STRING_EXTRA2,
          masterkey: dataExtraString3,
        });
        const user = {
          ...this.editedItemData,
          role: this.editedItemRole,
          mapping_user: this.componentsWilayah,
        };

        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('users/updateUser', {
              date,
              user,
              index: this.editedIndex,
            })
            .then((result) => {
              if (result.success) {
                this.close();
                showAlert(
                  this.$store,
                  'Update user success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                this.handleFieldErrors(result.data);
                const errorMessage = this.extractErrorMessage(result.data, 'Error on update user !');
                showAlert(
                  this.$store,
                  errorMessage,
                  'mdi-alert',
                  'red'
                );
              }
            });
        } else {
          const encryptedPassword = speEncrypt.encrypt(
            speEncrypt.encryption(this.editedItemData.password),
            '',
            extras
          );
          const passwordConfirmation = speEncrypt.encrypt(
            speEncrypt.encryption(this.editedItemData.passwordConfirmation),
            '',
            extras
          );
          await this.$store
            .dispatch('users/createUser', {
              date,
              user,
              encrypted_password: encryptedPassword,
              password_confirmation: passwordConfirmation,
            })
            .then((result) => {
              if (result.success) {
                this.close();
                showAlert(
                  this.$store,
                  'Create user success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                this.handleFieldErrors(result.data);
                const errorMessage = this.extractErrorMessage(result.data, 'Error on create user !');
                showAlert(
                  this.$store,
                  errorMessage,
                  'mdi-alert',
                  'red'
                );
              }
            });
        }
      }
    },
    handleFieldErrors(responseData) {
      if (!responseData) return;
      
      const { data } = responseData;
      
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        this.$store.commit('users/setErrors', data);
      }
    },
  },
};
</script>

<style scoped>
.change-email-alert {
  background-color: rgba(76, 175, 80, 0.1) !important;
  border-left: 4px solid #4caf50 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.change-email-alert .v-alert__icon {
  color: #4caf50 !important;
}

.change-email-title {
  color: #2e7d32;
  font-weight: bold;
}

.change-email-message {
  color: #558b2f;
  font-weight: normal;
}

.send-link-alert {
  background-color: rgba(76, 175, 80, 0.1) !important;
  border-left: 4px solid #4caf50 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.send-link-alert .v-alert__icon {
  color: #4caf50 !important;
}

.send-link-title {
  color: #2e7d32;
  font-weight: bold;
}

.send-link-message {
  color: #558b2f;
  font-weight: normal;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
